import { render, staticRenderFns } from "./AdminItemsTable.vue?vue&type=template&id=f1280afc"
import script from "./AdminItemsTable.vue?vue&type=script&lang=js"
export * from "./AdminItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1280afc')) {
      api.createRecord('f1280afc', component.options)
    } else {
      api.reload('f1280afc', component.options)
    }
    module.hot.accept("./AdminItemsTable.vue?vue&type=template&id=f1280afc", function () {
      api.rerender('f1280afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminItemsTable.vue"
export default component.exports